// /**
//  * This file is used to aggregate all the css files that are used by our views.  This is necessary because with webpack chunks,
//  * extract text is unable to create a style sheet for individual chunks.  To get around this, we load all the chunked styles
//  * here.
//  */
//
// //common
// import './common/FeaturedItem.sass';
// import './common/FeaturedSection.sass';
// import './common/imageHover.sass';
// import './common/pageJumbotron.sass';
// import './common/SelectElement.sass';
// import './common/SlickWrapper.sass';
// import './common/TwitchChatEmbed.sass';
// import './common/TwitchVideoEmbed.sass';
// import './common/YoutubeVideoEmbed.sass';
// import './common/VideoOverlay.sass';
// import './common/MousePosition.sass';
// import './common/DownloadButton.sass';
//
// //Download
// import './download/Download.sass';
//
// //error
// import './error/Error404.sass';
// import './error/error.sass';
// import './error/Error500.sass';
//
// //faq
// import './faq/faqSection.sass';
// import './faq/qasection.sass';
// import './faq/quickLink.sass';
//
//home
import './home/IntroSection.sass';
// import './home/FeaturedActivityList.sass';
// import './home/header.sass';
// import './home/Explore.sass';
// import './home/SearchForSurvivors.sass';
// import './home/HomeOverlay.sass';
//
//
// //loadScreen
// import './loadScreen/LoadScreen.sass';
//
// //search
// import './search/BingResult.sass';
// import './search/BingResultsList.sass';
//
// //squareButton
// import './squareButton/SquareButton.sass';
//
// //founders
// import './founders/Pack.sass';
// import './founders/PackBuyDialog.sass';
// import './founders/PackCompare.sass';
// import './founders/DetailHeader.sass';
// import './founders/StarterBlueprintsSection.sass';
// import './founders/StarterHerosSection.sass';
// import './founders/DefendersSection.sass';
// import './founders/PinataPacksSection.sass';
// import './founders/HeroExclusiveSection.sass';
// import './founders/FriendInviteSection.sass';
// import './founders/PackNavigation.sass';
// import './founders/BuyNowSection.sass';
// import './founders/BrCarousel.sass';
// import './founders/BrInfoSection.sass';
// import './founders/PackDropDown.sass';
// import './founders/MobilePackNav.sass';
//
// //store
// import './store/AssetPrice.sass';
//
// //Search for Survivors
// import './sfs/Commander.sass';
// import './sfs/Reward.sass';
// import './sfs/Thanks.sass';
// import './common/TextBlock.sass';
// import './sfs/ProgressBar.sass';
// import './sfs/ConfirmModal.sass';
// import './home/HomeBackup.sass';
// import './sfs/SocialShare.sass';
// import './founders/PopDown.sass';
//
// //watch
// import './watch/FeaturedVideos.sass';
// import './watch/FeatureVideo.sass';
// import './watch/Playlist.sass';
// import './watch/StreamCard.sass';
// import './watch/StreamOverlay.sass';
// import './watch/TwitchStreamList.sass';
// import './watch/VideoCard.sass';
// import './watch/YoutubeCard.sass';

//common
import './common/VideoOverlay.sass';

//newHome
import './newHome/IntroSection.sass';
import './newHome/GamePlaySection.sass';
import './newHome/RecruitHeroes.sass';
import './newHome/DiscoverKingdom.sass';
import './newHome/MasterElements.sass';
import './newHome/ForgeStronghold.sass';
import './newHome/Carousel.sass';
import './newHome/CarouselItem.sass';
import './newHome/Mage.sass';
import './newHome/Enemies.sass';
import './newHome/FlameSwords.sass';
import './newHome/WaterNinja.sass';
import './newHome/NinjaGirl.sass';
import './newHome/Puff.sass';
